import { debounce } from 'lodash-es'

const getLng = (lng) => {
  if (lng > 180) {
    return lng - 360
  } else if (lng < -180) {
    return lng + 360
  } else {
    return lng
  }
}

const makeBounds = (bounds) => {
  const northEastLng = getLng(bounds.northEast.lng)
  const southWestLng = getLng(bounds.southWest.lng)
  return [
    [northEastLng, bounds.northEast.lat],
    [southWestLng, bounds.northEast.lat],
    [southWestLng, bounds.southWest.lat],
    [northEastLng, bounds.southWest.lat],
    [northEastLng, bounds.northEast.lat],
  ]
}

const mapBounds = (
  opts = {
    debounceTime: 500,
  }
) => {
  const getBounds = (AMap, amap, layer) => () => {
    let bounds = makeBounds(amap.getBounds())

    return bounds
  }

  const setApis = (AMap, amap) => ({
    initBounds: (layer, { onChange }) => {
      const { debounceTime } = opts
      layer.getBounds = getBounds(AMap, amap, layer)

      if (!onChange) return

      amap.on(
        'moveend',
        debounce(
          () => {
            if (amap.clzoom && amap.clzoom < amap.getZoom()) {
              amap.clzoom = amap.getZoom()
              return
            }
            amap.clzoom = amap.getZoom()
            onChange(layer.getBounds())
          },
          debounceTime,
          { leading: false, trailing: true }
        )
      )
    },
  })
  return {
    amapPlugins: [],
    setApis,
  }
}

export default mapBounds
